import React, { createContext, useEffect, useRef, useState } from 'react';
import api from '../services/api';
export const MercadoLivreContext = createContext({});

function MercadoLivreProvider({ children }) {

    const [products,setProducts] = useState([])

    const getProducts = async (token) => {    
        const response = await api.get(`/mercado/livre/products`)
        console.log(response.data)
        if(response.status == 200){
            setProducts(response.data)
        }
    }
    const getProductsByName = async (name) => {
        const response = await api.post("/mercado/livre/product/by/name/",{
            searchTerm:name
        })

        if(response.status == 200){
            setProducts(response.data)
        }
    }

    return (
        <MercadoLivreContext.Provider value={{
            getProducts,
            products,
            getProductsByName
        }}>
            {children}
        </MercadoLivreContext.Provider>
    );
}

export default MercadoLivreProvider;
